// Placeholder Mongoose EVM mark (teal tile with an M, as on Cesar's beta flyer) until there's a real logo.
export function LogoMark({ size = 24 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden className="shrink-0">
      <rect width="32" height="32" rx="6" fill="#2d8b7f" />
      <path fill="#fff" d="M8 24V8h3.6L16 15.2 20.4 8H24v16h-3.4V13.9l-3.7 6h-1.8l-3.7-6V24z" />
    </svg>
  );
}

export function Logo({ size = 24, className }: { size?: number; className?: string }) {
  return (
    <span className={`flex items-center gap-2 ${className ?? ""}`}>
      <LogoMark size={size} />
      <span className="text-[13px] font-semibold uppercase tracking-[0.18em]">Mongoose EVM</span>
    </span>
  );
}
